<div>
  @if (editing && permissions) {
    <div>
      <div class="form-group row align-items-center">
        <label [class]="labelClass"  class="col-form-label block bold">{{label}} @if (required==true) {
          <span class="text-danger">*</span>
        } :</label>
        <div [class]="formClass">
          @if (items) {
            <ng-select [items]="items" [multiple]="multiple" [closeOnSelect]="closeOnSelect"
              #inlineEditSelectControl
              (click)="$event.stopPropagation()"
              class="form-control-plaintext editable-field" name="id" bindLabel="name"
              [(ngModel)]="value"
              id="selectedId"
              [disabled]="!item.editable"
              [placeholder]="label">
            </ng-select>
          }
          <span (click)="onBlur()" id="saveDiv" class="save"></span>
          <span (click)="previousValue($event)" id="rejectDiv" class="reject"></span>
          @if (required==true && (value == '' || value == null)) {
            <div>
              <small class="text-danger">Please enter {{label}}</small>
            </div>
          }
        </div>
      </div>
    </div>
  }
  @if (!editing) {
    <div>
      <div class="form-group row align-items-center height-38">
        <label [class]="labelClass"  class="col-form-label block bold">{{label}} @if (required==true) {
          <span class="text-danger">*</span>
        } :</label>
        <div [class]="formClass">
          <div (click)="edit($event, value)" (focus)="edit($event, value);" tabindex="0"
            [ngClass]="{'inline-edit': permissions && item.editable}" class=" form-control-plaintext" style="display: inline">
            @if (!item.editable) {
              @if (value && multiple==false) {
                <span class="small-size-text" ngbTooltip="View Only" placement="right" >{{value.name}}&nbsp;</span>
              }
              @if (value && multiple==true) {
                <span class="small-size-text" ngbTooltip="View Only" placement="right" >@for (data of value; track data; let islastindex = $last) {
                  <span>{{data}} {{islastindex ? '' : ','}}&nbsp;</span>
                }&nbsp;</span>
              }
              @if (!value) {
                <span class="small-size-text" ngbTooltip="View Only" placement="right" >--</span>
              }
              <!--<span class="small-size-text" ngbTooltip="View Only" placement="right"  *ngIf="multiple==true && !value.length">&#45;&#45;</span>-->
            }
            @if (item.editable) {
              @if (value && multiple==false) {
                <span>{{value.name}}&nbsp;</span>
              }
              @if (value && multiple==true) {
                <span>@for (data of value; track data; let islastindex = $last) {
                  <span>{{data}} {{islastindex ? '' : ','}}&nbsp;</span>
                }</span>
              }
              @if (!value) {
                <span class="link-color edit-text">click to set</span>
              }
              <!--<span class="link-color edit-text" *ngIf="multiple==true && !value.length">click to set</span>-->
            }
            <span class="edit-icon"></span>
          </div>
        </div>
      </div>
    </div>
  }
</div>


